import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a0f00 30%, #0d0700 60%, #0a0a0a 100%)'
  }} data-id="element-275">
      {/* Logo */}
      <div className="mb-4" data-id="element-276">
        <span className="text-[#F97316] text-xl sm:text-2xl font-black tracking-widest" data-id="element-277">
          🥊 PROFEPACK
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px]" data-id="element-278">
        Todo tu año de boxeo
        <br data-id="element-279" />
        <span className="text-[#F97316]" data-id="element-280">resuelto.</span>
      </h1>

      {/* Mockup image — LCP element, priority load con dimensiones explícitas */}
      <div className="w-full max-w-[280px] sm:max-w-[350px] md:max-w-[420px] mx-auto mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-281">
        <img src="https://cdn.magicpatterns.com/uploads/k2YsmDJZftDntFdj12pEmR/Sin_titulo_(420_x_420_px)_(12).png" alt="PROFEPACK MegaPack Boxeo Listo — Combo Completo" className="w-full h-full object-contain" width={350} height={350} fetchPriority="high" data-id="element-282" />
      </div>

      {/* Subtitle */}
      <p className="text-[#F97316] sm:text-2xl font-bold max-w-3xl mb-[0px] text-[14px]" data-id="element-283">
        6 Tomos · 140+ Clases · 6 Bonos · Listo para usar.
      </p>

      {/* Body */}
      <p className="text-white sm:text-lg max-w-2xl mb-[2px] pt-[8px] pb-[8px] text-[16px]" data-id="element-284">
        Tu año completo de boxeo listo: clases, técnica, potencia, defensa,
        táctica, guanteo y gestión. Sin improvisar. Sin cancelar. Sin quedarte
        sin ideas.
      </p>

      {/* Pills */}
      <div className="flex flex-nowrap mb-[10px] gap-[6px] items-center justify-center mx-auto" data-id="element-285">
        <span className="bg-black/50 border border-[#F97316]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-286">
          📄 PDF digital
        </span>
        <span className="bg-black/50 border border-[#F97316]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-287">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-black/50 border border-[#F97316]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-288">
          🥊 Todos los niveles
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-green-pulse bg-[#F97316] font-black sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#FB923C] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm text-[#FFFFFF] text-[16px]" data-id="element-289">
        💥 → QUIERO MI PROFEPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-290">
        <span data-id="element-291">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-292">🔒 Pago 100% seguro</span>
        <span data-id="element-293">💳 Mercado Pago · Tarjetas</span>
      </p>
    </section>;
}